/* DSL Facets memory — bewaar collection-page filters in URL hash, niet querystring */
(function(){
  var KEY = "dsl_facets_v1";
  function save(){
    var checked = [...document.querySelectorAll("input[name^=\"filter.\"]:checked")];
    if (!checked.length) return;
    var snap = checked.map(function(i){ return i.name + "=" + encodeURIComponent(i.value); }).join("|");
    try { sessionStorage.setItem(KEY, snap); } catch(e){}
  }
  document.addEventListener("change", function(e){
    if (e.target.matches("input[name^=\"filter.\"]")) save();
  });
})();